<nav
  class="ui-menubar"
  [class.ui-menubar--horizontal-scroll]="horizontalScroll()"
  [attr.aria-label]="ariaLabel()"
>
  <div class="ui-menubar__inner">
    <div class="ui-menubar__start">
      <ng-content select="[data-ui-menubar-start]" />
    </div>

    <ul class="ui-menubar__list" role="menubar" (scroll)="onListScroll($event)">
      @for (item of items(); track item.id) {
        <li class="ui-menubar__li" role="none">
          @if (item.items?.length) {
            <div class="ui-menubar__submenu-root">
              <button
                type="button"
                class="ui-menubar__item ui-menubar__item--trigger"
                [class.ui-menubar__item--active]="item.active"
                [class.ui-menubar__item--open]="openSubmenuId() === item.id && !item.active"
                role="menuitem"
                [attr.aria-expanded]="openSubmenuId() === item.id"
                aria-haspopup="true"
                [attr.aria-controls]="submenuPanelId(item.id)"
                [disabled]="item.disabled"
                (click)="toggleSubmenu(item.id, $event)"
              >
                @if (item.iconSrc) {
                  <img class="ui-menubar__icon" [src]="item.iconSrc" alt="" aria-hidden="true" width="18" height="18" />
                }
                <span class="ui-menubar__label">{{ item.label }}</span>
                <span class="ui-menubar__trigger-chevron" aria-hidden="true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M6 9l6 6 6-6" />
                  </svg>
                </span>
              </button>
              @if (openSubmenuId() === item.id) {
                <ul
                  class="ui-menubar__submenu"
                  [class.ui-menubar__submenu--fixed]="horizontalScroll()"
                  role="menu"
                  [id]="submenuPanelId(item.id)"
                  [style.top.px]="submenuPosition()?.top"
                  [style.left.px]="submenuPosition()?.left"
                  (click)="$event.stopPropagation()"
                >
                  @for (sub of item.items!; track $index) {
                    @if (sub.separator) {
                      <li class="ui-menubar__submenu-sep" role="presentation">
                        <hr class="ui-menubar__hr" />
                      </li>
                    } @else if (sub.items?.length) {
                      <li class="ui-menubar__submenu-li ui-menubar__submenu-li--nested" role="none">
                        <button
                          type="button"
                          class="ui-menubar__submenu-item ui-menubar__submenu-item--trigger"
                          role="menuitem"
                          [attr.aria-expanded]="openNestedSubmenuId() === sub.id"
                          aria-haspopup="true"
                          [attr.aria-controls]="submenuPanelId(sub.id)"
                          [disabled]="sub.disabled"
                          [class.ui-menubar__item--open]="openNestedSubmenuId() === sub.id"
                          [class.ui-menubar__item--active]="sub.active && !sub.items?.length"
                          (click)="toggleNestedSubmenu(sub.id, $event)"
                        >
                          @if (sub.iconSrc) {
                            <img class="ui-menubar__icon" [src]="sub.iconSrc" alt="" aria-hidden="true" width="18" height="18" />
                          }
                          <span class="ui-menubar__label">{{ sub.label }}</span>
                          <span class="ui-menubar__nested-chevron" aria-hidden="true">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                              <path d="M9 6l6 6-6 6" />
                            </svg>
                          </span>
                        </button>
                        @if (openNestedSubmenuId() === sub.id) {
                          <ul
                            class="ui-menubar__submenu ui-menubar__submenu--nested"
                            role="menu"
                            [id]="submenuPanelId(sub.id)"
                            (click)="$event.stopPropagation()"
                          >
                            @for (leaf of sub.items!; track $index) {
                              @if (leaf.separator) {
                                <li class="ui-menubar__submenu-sep" role="presentation">
                                  <hr class="ui-menubar__hr" />
                                </li>
                              } @else {
                                <li class="ui-menubar__submenu-li" role="none">
                                  @if (leaf.routerLink) {
                                    <a
                                      class="ui-menubar__submenu-item"
                                      role="menuitem"
                                      [routerLink]="leaf.routerLink"
                                      [class.ui-menubar__item--disabled]="leaf.disabled"
                                      [attr.aria-disabled]="leaf.disabled ? 'true' : null"
                                      [attr.tabindex]="leaf.disabled ? -1 : 0"
                                      (click)="activateLeaf(leaf, $event)"
                                    >
                                      @if (leaf.iconSrc) {
                                        <img class="ui-menubar__icon" [src]="leaf.iconSrc" alt="" aria-hidden="true" width="18" height="18" />
                                      }
                                      <span class="ui-menubar__label">{{ leaf.label }}</span>
                                    </a>
                                  } @else if (leaf.href) {
                                    <a
                                      class="ui-menubar__submenu-item"
                                      role="menuitem"
                                      [href]="leaf.href"
                                      [attr.target]="leaf.hrefTarget ?? null"
                                      [attr.rel]="leaf.hrefRel ?? (leaf.hrefTarget === '_blank' ? 'noopener noreferrer' : null)"
                                      [class.ui-menubar__item--disabled]="leaf.disabled"
                                      [attr.aria-disabled]="leaf.disabled ? 'true' : null"
                                      [attr.tabindex]="leaf.disabled ? -1 : 0"
                                      (click)="activateLeaf(leaf, $event)"
                                    >
                                      @if (leaf.iconSrc) {
                                        <img class="ui-menubar__icon" [src]="leaf.iconSrc" alt="" aria-hidden="true" width="18" height="18" />
                                      }
                                      <span class="ui-menubar__label">{{ leaf.label }}</span>
                                    </a>
                                  } @else {
                                    <button
                                      type="button"
                                      class="ui-menubar__submenu-item"
                                      role="menuitem"
                                      [disabled]="leaf.disabled"
                                      (click)="activateLeaf(leaf, $event)"
                                    >
                                      @if (leaf.iconSrc) {
                                        <img class="ui-menubar__icon" [src]="leaf.iconSrc" alt="" aria-hidden="true" width="18" height="18" />
                                      }
                                      <span class="ui-menubar__label">{{ leaf.label }}</span>
                                    </button>
                                  }
                                </li>
                              }
                            }
                          </ul>
                        }
                      </li>
                    } @else if (sub.routerLink) {
                      <li class="ui-menubar__submenu-li" role="none">
                        <a
                          class="ui-menubar__submenu-item"
                          role="menuitem"
                          [routerLink]="sub.routerLink"
                          [class.ui-menubar__item--disabled]="sub.disabled"
                          [attr.aria-disabled]="sub.disabled ? 'true' : null"
                          [attr.tabindex]="sub.disabled ? -1 : 0"
                          (click)="activateLeaf(sub, $event)"
                        >
                          @if (sub.iconSrc) {
                            <img class="ui-menubar__icon" [src]="sub.iconSrc" alt="" aria-hidden="true" width="18" height="18" />
                          }
                          <span class="ui-menubar__label">{{ sub.label }}</span>
                        </a>
                      </li>
                    } @else if (sub.href) {
                      <li class="ui-menubar__submenu-li" role="none">
                        <a
                          class="ui-menubar__submenu-item"
                          role="menuitem"
                          [href]="sub.href"
                          [attr.target]="sub.hrefTarget ?? null"
                          [attr.rel]="sub.hrefRel ?? (sub.hrefTarget === '_blank' ? 'noopener noreferrer' : null)"
                          [class.ui-menubar__item--disabled]="sub.disabled"
                          [attr.aria-disabled]="sub.disabled ? 'true' : null"
                          [attr.tabindex]="sub.disabled ? -1 : 0"
                          (click)="activateLeaf(sub, $event)"
                        >
                          @if (sub.iconSrc) {
                            <img class="ui-menubar__icon" [src]="sub.iconSrc" alt="" aria-hidden="true" width="18" height="18" />
                          }
                          <span class="ui-menubar__label">{{ sub.label }}</span>
                        </a>
                      </li>
                    } @else {
                      <li class="ui-menubar__submenu-li" role="none">
                        <button
                          type="button"
                          class="ui-menubar__submenu-item"
                          role="menuitem"
                          [disabled]="sub.disabled"
                          (click)="activateLeaf(sub, $event)"
                        >
                          @if (sub.iconSrc) {
                            <img class="ui-menubar__icon" [src]="sub.iconSrc" alt="" aria-hidden="true" width="18" height="18" />
                          }
                          <span class="ui-menubar__label">{{ sub.label }}</span>
                        </button>
                      </li>
                    }
                  }
                </ul>
              }
            </div>
          } @else if (item.routerLink) {
            <a
              class="ui-menubar__item"
              [class.ui-menubar__item--active]="item.active"
              role="menuitem"
              [routerLink]="item.routerLink"
              [class.ui-menubar__item--disabled]="item.disabled"
              [attr.aria-disabled]="item.disabled ? 'true' : null"
              [attr.tabindex]="item.disabled ? -1 : 0"
              (click)="activateLeaf(item, $event)"
            >
              @if (item.iconSrc) {
                <img class="ui-menubar__icon" [src]="item.iconSrc" alt="" aria-hidden="true" width="18" height="18" />
              }
              <span class="ui-menubar__label">{{ item.label }}</span>
            </a>
          } @else if (item.href) {
            <a
              class="ui-menubar__item"
              [class.ui-menubar__item--active]="item.active"
              role="menuitem"
              [href]="item.href"
              [attr.target]="item.hrefTarget ?? null"
              [attr.rel]="item.hrefRel ?? (item.hrefTarget === '_blank' ? 'noopener noreferrer' : null)"
              [class.ui-menubar__item--disabled]="item.disabled"
              [attr.aria-disabled]="item.disabled ? 'true' : null"
              [attr.tabindex]="item.disabled ? -1 : 0"
              (click)="activateLeaf(item, $event)"
            >
              @if (item.iconSrc) {
                <img class="ui-menubar__icon" [src]="item.iconSrc" alt="" aria-hidden="true" width="18" height="18" />
              }
              <span class="ui-menubar__label">{{ item.label }}</span>
            </a>
          } @else {
            <button
              type="button"
              class="ui-menubar__item"
              [class.ui-menubar__item--active]="item.active"
              role="menuitem"
              [disabled]="item.disabled"
              (click)="activateLeaf(item, $event)"
            >
              @if (item.iconSrc) {
                <img class="ui-menubar__icon" [src]="item.iconSrc" alt="" aria-hidden="true" width="18" height="18" />
              }
              <span class="ui-menubar__label">{{ item.label }}</span>
            </button>
          }
        </li>
      }
    </ul>

    <div class="ui-menubar__end">
      <ng-content select="[data-ui-menubar-end]" />
    </div>
  </div>
</nav>
